const currency = window?.Shopify?.currency?.active || 'EUR';
let locale = 'de-DE';
if(currency === 'CHF') {
    locale = 'de-CH'
}
if(currency === 'GBP') {
    locale = 'en-GB'
}
if(window?.Shopify?.locale === 'fr') {
    locale = 'fr-FR'
}
if(window?.Shopify?.locale === 'es') {
    locale = 'es-ES'
}
if(window?.Shopify?.locale === 'it') {
    locale = 'it-IT'
}


const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: "narrowSymbol",
  });

export const formatMoney = function(cents) {
      const amount = cents / 100;
      return formatter.format(amount);
  }

